import { render, staticRenderFns } from "./teamAdd.vue?vue&type=template&id=1f5b75d2&"
import script from "./teamAdd.vue?vue&type=script&lang=js&"
export * from "./teamAdd.vue?vue&type=script&lang=js&"
import style0 from "./teamAdd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./teamAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports